import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Toaster } from 'sonner'
import './index.css'
import { AuthProvider } from './contexts/AuthContext'
import { LoadingBarProvider } from './contexts/LoadingBarContext'
import App from './App.tsx'

createRoot(document.getElementById('root')!).render(
  <BrowserRouter>
    <AuthProvider>
      <LoadingBarProvider>
        <App />
        <Toaster richColors position='top-right' theme='light' />
      </LoadingBarProvider>
    </AuthProvider>
  </BrowserRouter>
)
